import styled from 'styled-components';
import { setRem } from '../../utils/styles';

export const Wrapper = styled.div`
  margin-bottom: ${setRem(48)};

  p + * {
    margin-top: ${setRem(20)};
  }
`;
